import {fetchGuideUpdate, Guide} from '@blesk-frontend/api';
import {useMutation, useQueryClient} from '@tanstack/react-query';

/**
 * This mutation hook is used to update the Guide.
 */
export const useGuideUpdateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fetchGuideUpdate,
    onSuccess(data) {
      queryClient.setQueryData<Guide>(['guides', {id: data.id}], (d) => ({
        ...d,
        ...data,
      }));
    },
  });
};
